"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_SCHEME_DEFAULTS = void 0;
exports.COLOR_SCHEME_DEFAULTS = {
    defaultColorScheme: "light",
    getUserSettings: () => localStorage.getItem("theme"),
    respectSystemSetting: true,
    respectUserSettings: true,
    setUserSettings: (colorScheme) => localStorage.setItem("theme", colorScheme),
};
